import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmailTemplateDataService } from 'src/app/services/email-template-data.service';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ZpDataService } from 'src/app/services/zp-data.service';
import { ThemeService } from 'src/app/theme/theme-service.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-email-preview',
    templateUrl: './email-preview.component.html',
    styleUrls: ['./email-preview.component.scss'],
    standalone: false
})
export class EmailPreviewComponent implements OnInit {
  public activeTheme: any;
  public invitationSent: boolean = false;
  public retrievedData: any;
  public emailSubject: any;
  public emailBody: any;
  public emailUser: any;
  public userList: any;
  public placeholders: any;
  public selectedUser: any;
  public isInviteOnly: boolean;
  public emailBodyToDisplay: SafeHtml;
  public extractedText: string;

  constructor(
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private router: Router,
    private emailTemplateDataService: EmailTemplateDataService,
    private api: ZpDataService,
    private sanitizer: DomSanitizer
  ) { }

  extractTextFromBody(html: string): string | null {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    const bodyDiv = doc.getElementById('body');
    if (bodyDiv) {
      return bodyDiv.innerHTML || '';
    }

    return null;
  }

  async ngOnInit() {
    this.activeTheme = this.themeService.active;
    this.retrievedData = await this.emailTemplateDataService.getData();
    console.log('retrievedData: ', this.retrievedData);
    this.emailUser = this.retrievedData.data.userList[0]["email"];
    console.log(this.retrievedData);
    if (this.retrievedData) {
      console.log('retrieved data - ', this.retrievedData);
      if (this.retrievedData.data.userList.length === 1) {
        this.isInviteOnly = true;
      } else {
        this.isInviteOnly = false;
      }
      this.emailSubject = this.retrievedData.data.mailSubject;
      this.placeholders = this.retrievedData.placeholders.placeholders;
      this.userList = this.retrievedData.data.userList;
      let user = JSON.parse(JSON.stringify(this.userList[0]));
      user.first = user.firstName;
      user.last = user.lastName;
      this.emailBodyToDisplay = this.sanitizer.bypassSecurityTrustHtml(this.applyTemplate(this.retrievedData.data.mailBody, this.placeholders, user));
      this.emailSubject = this.applyTemplate(this.retrievedData.data.mailSubject, this.placeholders, user);
      // console.log('retrievedData.data.emailBody: ', this.retrievedData.data.mailBody);
    }
    this.extractedText = this.extractTextFromBody(this.retrievedData.data.mailBody);
    // if (this.extractedText) {
    //   console.log('extractedText', this.extractedText);
    // }
  }

  applyTemplate(template: string, data: any[], user?: any): string {
    let content = template + '';
    const regex = /\[([^\]]+)\]/g;
    const toReplace = this.matchAll(content, regex);
    for (let k of toReplace) {
      let obj = data.find(item => item.value.includes(k[0]));
      content = content.replace(
        k[0],
        k[1].startsWith('user') ? user[k[1].substring(k[1].indexOf('.') + 1)] : (obj ? obj.preview : '')
      );
    }
    return content;
  }

  matchAll(content: string, regex: RegExp): RegExpMatchArray[] {
    const matches: RegExpMatchArray[] = [];
    let match;
    while ((match = regex.exec(content)) !== null) {
      matches.push(match);
    }
    return matches;
  }


  sendEmail() {
    this.sendInvites();
    this.invitationSent = true;
  }

  async sendInvites() {
    const emailPreviewToSend = {
      mailBody: this.retrievedData.data.mailBody,
      mailSubject: this.retrievedData.data.mailSubject,
      userList: this.userList,
      reminder: this.retrievedData.data.reminder,
      customizedMailBody: this.extractedText
    };

    try {
      const response = await this.api.sendInvites(emailPreviewToSend);
      alert('Your email has been sent successfully.');
      console.log(emailPreviewToSend);
      console.log(response);
    } catch (error) {
      alert('There was a problem sending your email. Please try again later.');
      console.error(error);
    }
  }

  onSelectUser(user) {
    this.selectedUser = JSON.parse(user);
    this.selectedUser.first = this.selectedUser.firstName;
    this.selectedUser.last = this.selectedUser.lastName;
    this.emailBody = this.applyTemplate(this.retrievedData.data.mailBody, this.retrievedData.placeholders.placeholders, this.selectedUser);
    this.emailBodyToDisplay = this.sanitizer.bypassSecurityTrustHtml(this.emailBody);
    this.emailSubject = this.applyTemplate(this.retrievedData.data.mailSubject, this.retrievedData.placeholders.placeholders, this.selectedUser);
    this.emailUser = this.selectedUser.email;
  }

  returnToEmailTemplate() {
    this.emailTemplateDataService.setData(this.retrievedData.data);
    this.router.navigate(['/email-template']);
  }

  goToHomePage() {
    this.router.navigate(["/professional-home-page"], {
      queryParams: {
        redirectToAccountsCreated: true,
        redirectToInvitesSent: true,
      },
    });
  }
}
